import Vue from 'vue'
import Router from 'vue-router'


// import HomePage from '@/components/HomePage'
import HelloWorld from '@/components/Home.vue'
import OtherHome from '@/components/OtherHome.vue'
import About from '@/components/About.vue'
import Projects from '@/components/AllProjects.vue'
import ProjectView from '@/components/ProjectPartial.vue'
import Works from '@/components/Works.vue'
import EnterpriseProjects from '@/components/EnterpriseProjects.vue'
import ClassProjects from '@/components/ClassProjects.vue'
import Extra from '@/components/Extra.vue'
import Experience from '@/components/Experience.vue'


Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'OtherHomePage',
      component: OtherHome,
    },
    {
      path: '/Other',
      name: 'OtherHomePage',
      component: OtherHome,
    },
    {
      path: '/Works',
      name: 'WorksPage',
      component: Works,
      children: [
        {
          path: '/Works/Enterprise',
          name: 'EnterpriseProjectsPage',
          component: EnterpriseProjects,
        },
        {
          path: '/Works/Class',
          name: 'ClassProjectsPage',
          component: ClassProjects,
        },

      ]
    },
    {
      path: '/Works/:Type',
      name: 'WorksTypesPage',
      component: Works,
      children: [
        {
          path: '/Works/Class',
          name: 'ClassProjectsPage',
          component: ClassProjects,
        },

      ]
    },
    {
      path: '/Extra',
      name: 'ExtraPage',
      component: Extra
    },
    {
      path: '/About',
      name: 'AboutPage',
      component: About
    },
    {
      path: '/Experience',
      name: 'ExperiencePage',
      component: Experience
    },
    {
      path: '/AllProjects',
      name: 'AllProjectsPage',
      component: Projects
    }
    ,
    {
      path: '/Works/Class/Projects/:id',
      name: 'ProjectPartialPage',
      component: ProjectView,
      props: true
    },
    {
      path: '/Works/Enterprise',
      name: 'EnterpriseProjectsPage',
      component: EnterpriseProjects,
    }
  ]
})


export default router